import React from 'react';
import { Droplets, Car, Sparkles, Shield } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const services = [{
  icon: Droplets,
  title: 'Lavado Exterior Premium',
  description: 'Eliminamos suciedad, barro, polvo y contaminantes para devolverle el brillo original a tu vehículo.'
}, {
  icon: Car,
  title: 'Limpieza Interior Completa',
  description: 'Aspirado, limpieza de plásticos, paneles, alfombras y tapizados para un interior renovado.'
}, {
  icon: Sparkles,
  title: 'Detallado Profesional',
  description: 'Tratamientos específicos para devolver el mejor aspecto a cada parte del vehículo con máxima atención al detalle.'
}, {
  icon: Shield,
  title: 'Protección y Terminación',
  description: 'Aplicación de productos de protección para mantener la limpieza y el brillo durante más tiempo.'
}];
export function Services() {
  return <section className="py-16 bg-brand-dark relative" data-id="element-97">
      <div className="container mx-auto px-4 md:px-6" data-id="element-98">
        <FadeIn className="text-center mb-10" data-id="element-99">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-100">
            Nuestros <span className="text-brand-red" data-id="element-101">Servicios</span>
          </h2>
          <div className="w-24 h-1 bg-brand-red mx-auto" data-id="element-102"></div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-103">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <FadeIn key={index} delay={0.1 * index} className="bg-brand-darker border border-white/5 p-8 rounded-sm hover:-translate-y-2 transition-transform duration-300 relative overflow-hidden group" data-id="element-104">
                <div className="absolute top-0 left-0 w-full h-1 bg-brand-red transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-105"></div>

                <div className="flex items-start gap-6" data-id="element-106">
                  <div className="bg-brand-red/10 p-4 rounded-sm text-brand-red" data-id="element-107">
                    <Icon className="w-8 h-8" data-id="element-108" />
                  </div>
                  <div data-id="element-109">
                    <h3 className="text-2xl font-bold mb-3 text-white" data-id="element-110">
                      {service.title}
                    </h3>
                    <p className="text-brand-muted leading-relaxed" data-id="element-111">
                      {service.description}
                    </p>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}